module.exports = __webpack_public_path__ + "img/headphones.60177b2a.svg";